import { createSelector } from "reselect";

import AccessChangeNotice from "@app/enum/AccessChangeNotice";
import type { RootState } from "@app/store/rootReducer";

const accessChangeState = (state: RootState) => state.accessChange;

export const getAccessChangeNotice = createSelector(
  accessChangeState,
  ({ accessChangeNotice }) => accessChangeNotice
);

export const isAccessChangePromptVisible = createSelector(
  accessChangeState,
  ({ accessChangePromptVisible }) => accessChangePromptVisible
);

export const getAccessChangeRevision = createSelector(
  accessChangeState,
  ({ revision }) => revision
);

export const isReloadPending = createSelector(
  getAccessChangeNotice,
  (accessChangeNotice) => accessChangeNotice === AccessChangeNotice.RELOAD_PENDING
);
